/* @ngInject */
const trainFields = (
  trainLabels,
  types,
  icons
) => {
  const self = {}

  self.id = {
    ref: 'id',
    label: trainLabels.fields.id.text,
    icon: icons.train.area,
    output: false,
  }

  self.tractionnaire = {
    ref: 'tractionnaire',
    label: trainLabels.fields.tractionnaire.text,
    icon: icons.train.tractionnaire,
    required: true,
    type: types.text(),
    output: {
      sortable: true,
      table: { prefill: true, },
      excel: { prefill: true, },
      style: { overflow: true, },
    },
  }

  self.date = {
    ref: 'date',
    label: trainLabels.fields.date.text,
    icon: icons.train.date,
    required: true,
    type: types.date,
    output: {
      sortable: true,
      table: { prefill: true, },
      excel: { prefill: true, },
      style: { overflow: true, },
    },
  }

  self.number = {
    ref: 'number',
    label: trainLabels.fields.number.text,
    icon: icons.train.number,
    type: types.text(),
    output: {
      sortable: true,
      table: { prefill: true, },
      excel: { prefill: true, },
      style: { overflow: true, },
    },
  }

  self.arrival = {
    ref: 'arrival',
    label: trainLabels.fields.arrival.text,
    icon: icons.train.arrival,
    type: 'bool',
    output: {
      sortable: true,
      table: { prefill: true, },
      excel: { prefill: true, },
      style: { overflow: true, },
    },
  }

  self.dateBegin = {
    ref: 'dateBegin',
    label: trainLabels.fields.dateBegin.text,
    icon: icons.train.date,
    type: types.date,
    output: false,
  }

  self.dateEnd = {
    ref: 'dateEnd',
    label: trainLabels.fields.dateEnd.text,
    icon: icons.train.date,
    type: types.date,
    output: false,
  }

  self.wagonCount = {
    ref: 'wagonCount',
    label: trainLabels.fields.wagonCount.text,
    icon: icons.train.wagonCount,
    output: {
      sortable: true,
      table: { prefill: true, },
      excel: { prefill: true, },
      style: { overflow: true, },
    },
  }

  return self
}
export default trainFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/resources/fields.resource.js